export function isPublicConsultaEnabled(tenant) {
  if (!tenant || tenant.public_consulta_enabled == null) return true;
  return Boolean(tenant.public_consulta_enabled);
}

export function isPublicDenunciaEnabled(tenant) {
  if (!tenant || tenant.public_denuncia_enabled == null) return true;
  return Boolean(tenant.public_denuncia_enabled);
}
